import { useContext } from 'react';
import { QueryFunction } from '@tanstack/react-query';
import { AddQueryFnContext } from '../definitions/types';

/**
 * Hook to add a query function to the context
 * @param key - the key of the slice of query functions
 * @param queryFns - the query functions to add
 */
export function useAddQueryFnContext(
  key: string,
  queryFns: Record<string, QueryFunction>,
) {
  const addFn = useContext(AddQueryFnContext);

  addFn(key, queryFns);
}
